import { ca } from '@cian/analytics';

import { getTermValue, TJsonQuery } from '../../../packages/JsonQuery';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import {
  IPublicWebV1SearchResponse,
  TPublicWebV1SearchResponse_MlRanking,
} from '../../common/repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { mlSearchSession } from '../../common/utils/mlSearchSession';
import { OFFERS_ON_PAGE, trackingReasonToListingType } from '../constants';

const trackListingOpen = (
  reason: 'all_objects_on_map' | 'pin_click',
  pageNumber: number,
  products: TProduct[],
  jsonQuery: IJsonQuery,
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined,
  queryString: string | null | undefined,
) => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      listingType: trackingReasonToListingType[reason],
      pageType: 'Listing',
      offersQty: products.length < OFFERS_ON_PAGE ? products.length : OFFERS_ON_PAGE,
      pageNumber,
      extra: {
        reason,
        mobileWebsiteType: 'new',
        mlSearchSessionGuid: mlSearchSession.getSessionGuid(jsonQuery),
        mlRankingGuid: mlRanking?.guid,
        mlRankingModelVersion: mlRanking?.modelVersion,
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products,
    sc: jsonQuery,
  });
};

type TProduct = {
  id: number;
  position: number;
  offerType: 'offer';
  extra?: {
    test_ota?: boolean;
    isPriceWithDiscount?: boolean;
  };
};

export const trackListingShow =
  (reason: 'all_objects_on_map' | 'pin_click') =>
  ({ offers, jsonQuery, mlRanking, queryString }: Partial<IPublicWebV1SearchResponse>) => {
    if (!offers?.length) {
      return;
    }

    const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;
    const offersPositionOffset = (pageNumber - 1) * OFFERS_ON_PAGE;
    const products = offers.reduce((acc, offer, index) => {
      const product: TProduct = {
        id: offer.id,
        position: index + 1 + offersPositionOffset,
        offerType: 'offer',
        extra: {
          isPriceWithDiscount: Boolean(offer.discount),
        },
      };

      return [...acc, product];
    }, []);

    trackListingOpen(reason, pageNumber, products, jsonQuery as TJsonQuery, mlRanking, queryString);
  };
